export const paletteColors = [
    'blue',
    'red',
    'green',
    'yellow',
    'cyan',
    'purple',
    'gray',
    'cool-gray',
] as const;
type PaletteColors = (typeof paletteColors)[number];
export const paletteLevels = [
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
] as const;
type PaletteLevels = (typeof paletteLevels)[number];

export type PaletteColorProp = `var(--${PaletteColors}-${PaletteLevels})`;

export type SizeConditional<T extends {}> = T | { mobile: T; desktop?: T };
export function useExtractSize<T extends {}>(
    size: MaybeRefOrGetter<SizeConditional<T> | undefined>,
    defaultValue?: T
) {
    const mobileSize = computed(() => {
        const sizeValue = toValue(size);
        if (
            typeof sizeValue === 'object' &&
            ('desktop' in sizeValue || 'mobile' in sizeValue)
        ) {
            return sizeValue.mobile ?? defaultValue;
        }
        return sizeValue ?? defaultValue;
    });
    const desktopSize = computed(() => {
        const sizeValue = toValue(size);
        if (
            typeof sizeValue === 'object' &&
            ('desktop' in sizeValue || 'mobile' in sizeValue)
        ) {
            return sizeValue.desktop ?? defaultValue;
        }
        return sizeValue ?? defaultValue;
    });
    return {
        mobile: mobileSize,
        desktop: desktopSize,
    };
}
